import axios, { AxiosError, AxiosResponse } from 'axios';
import { messagesError } from '../core/services/messages.services';
import auth from './auth';
import { UserInfo } from '../shared/interface/user-info';

const LoadUserInfo = {
  async getUserInfo(): Promise<UserInfo> {
    const jwtToken = auth.auth.getSignInUserSession().getAccessToken().getJwtToken();
    const idToken = auth.auth.getSignInUserSession().getIdToken().getJwtToken();
    localStorage.setItem('token', idToken);
    const USERINFO_URL = 'https://' + auth.auth.getAppWebDomain() + '/oauth2/userInfo';
    const requestData = {
      headers: {
        Authorization: 'Bearer ' + jwtToken,
      },
    };
    return axios
      .get(USERINFO_URL, requestData)
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
      });
  },
};

export default LoadUserInfo;
